import { type GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import {
  HOUR,
  isEmpty,
  isNotEmpty,
  type UniversalSearchInput,
  type UniversalSearchItem,
  type UniversalSearchSuccess,
} from '@terros/common'

export function useUniversalSearchQuery(
  input: UniversalSearchInput,
  enabled = true
): GetHookResponse<UniversalSearchItem[]> {
  return useTantalimQuery<UniversalSearchInput, UniversalSearchSuccess, UniversalSearchItem[]>({
    url: '/search',
    queryKey: ['search', input],
    input: {
      ...input,
      scopes: isEmpty(input.scopes) ? undefined : input.scopes,
    },
    convertResponse: (data) => data.results,
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: isNotEmpty(input.query) && enabled,
    },
  })
}
